import React, { useContext, useRef } from "react";
import Navbar from "../components/Navbar";
import img2 from "../assets/ignite-flyer.jpg";
import FormContext from "../FormContext";
import { useParams } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { BsFillClockFill, BsPinMap, BsArrowBarLeft } from "react-icons/bs";
import Footer from "../components/Footer";
import moment from "moment";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { data } from "../data";
import { IoMdPricetags } from "react-icons/io";

const SingleSession = () => {
  const { sessions } = useContext(FormContext);

  const { id } = useParams();
  const sessionData = sessions.find(
    (session) => String(session?.sessionId) === String(id)
  );



  const handleBack = () => {
    window.history.back();
  };

  const sessionRef = useRef(null);
  const speakersRef = useRef(null);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(sessionRef.current, {
      x: -100,
      opacity: 0,
      duration: 1,
      ease: "in-out",
      scrollTrigger: {
        trigger: sessionRef.current,
        start: "top 80%",
        end: "top 50%",
        toggleActions: "play none none reverse",
      },
    });

    gsap.from(speakersRef.current, {
      x: -100,
      opacity: 0,
      duration: 1,
      ease: "in-out",
      scrollTrigger: {
        trigger: speakersRef.current,
        start: "top 80%",
        end: "top 50%",
        toggleActions: "play none none reverse",
      },
    });
  }, []);
  return (
    <div className="w-full min-h-screen bg-gray-100">
      <Navbar />

      {/*  a button to go back to the sessions page */}
      <div className="w-11/12 mx-auto mt-8">
        <button
          className="text-primary-color font-nueu text-xl rounded-md flex items-center gap-2"
          onClick={handleBack}
        >
          <BsArrowBarLeft className="text-primary-color" />
          Back to Sessions
        </button>
      </div>

      <div className="w-full md:w-4/5 mx-auto mt-6 mb-6 p-3 md:p-0">
        <div className="w-full relative h-full md:min-h-80 flex flex-col md:flex-row gap-2 bg-white rounded-lg overflow-clip">
          <div className="w-full md:w-4/5 h-full">
            <img
              src={id === "71" ? "https://smescaleup.org/banner-sme.png" : sessionData?.imageURL ?
                sessionData?.imageURL : img2}

              alt="session"
              className="w-full min-h-[400px] max-h-[550px] h-full rounded-lg md:rounded-l-lg object-center object-cover"
            />
          </div>
          <div className="w-full md:w-full justify-between flex flex-col gap-4 p-4">
            <div className="flex items-center flex-wrap justify-between gap-2 md:gap-0">
              <h2 className="text-4xl font-semibold text-secondary-color font-nueu">
                {sessionData?.title}
              </h2>
              <div className="flex gap-2 items-center text-[#EF4B32] text-xl">
                <IoMdPricetags className="" />
                <div>
                  {sessionData?.sessionId === 71 ? (
                    <div className="flex items-center">
                      <span className="text-red-600 font-bold text-lg">₦135,000</span>
                      <del className="text-gray-400 mx-2 font-light line-through text-sm">₦150,000</del>
                      <span className="ml-2 bg-red-100 text-red-800 text-xs px-2 py-1 rounded">10% OFF</span>
                    </div>
                  ) : sessionData?.sessionDefaultPromo ? (
                    <div className="flex items-center flex-row-reverse">
                      <del className="text-gray-300 mx-2 font-light line-through text-sm">
                        &#8358;{sessionData?.cost.toLocaleString()}
                      </del>
                      &#8358;{sessionData?.sessionDefaultPromo.amount.toLocaleString()}
                    </div>
                  ) : (
                    <span className="">&#8358;{sessionData?.cost.toLocaleString()}</span>
                  )}
                </div>
              </div>


            </div>
            {id === "71" ? (
              <p className="text-gray-600 text-sm mb-4">
                <strong>ONLINE CLASSES · NASSI Special</strong><br /><br />
                Instalment Payment Plan:<br />
                <ul className="list-disc list-inside">
                  <li>₦15,000 — Today (Secure your spot)</li>
                  <li>₦30,000 — June 2025</li>
                  <li>₦30,000 — July 2025</li>
                  <li>₦30,000 — August 2025</li>
                  <li>₦30,000 — September 2025</li>
                </ul>
                <br />
                Join a transformative 3-month program designed to help businesses overcome challenges and achieve sustainable growth. Through immersive workshops, real-world case studies, and practical simulations, you’ll build the skills and strategies to rebuild, reinvent, and scale your business for lasting success.
              </p>
            ) : (
              <p
                className="text-gray-600 text-sm mb-4 line-clamp-6"
                dangerouslySetInnerHTML={{ __html: sessionData?.description }}
              ></p>
            )}


            <div className="flex flex-col gap-4">
              <div className="flex gap-2 items-center">
                <FaCalendarAlt className="text-secondary-color" />
                <p>{moment(sessionData?.date).format("MMMM Do YYYY")}</p>
              </div>
              <div className="flex gap-2 items-center">
                <BsFillClockFill className="text-secondary-color" />
                <p>
                  {" "}
                  {moment(sessionData?.date)
                    .startOf("day")
                    .add(8, "hours")
                    .format("h:mm a")}
                </p>
              </div>
              {
                // if isVirtual is true then display virtual else display physical
                sessionData?.isVirtual ? (
                  <div className="flex gap-2 items-center">
                    <BsPinMap className="text-secondary-color" />
                    <p>Virtual</p>
                  </div>
                ) : (
                  <div className="flex gap-2 items-center">
                    <BsPinMap className="text-secondary-color" />
                    <p>{sessionData?.location}</p>
                  </div>
                )
              }
            </div>

            {/*  button to register for the session */}
            <Link
              to={`/register/${sessionData?.sessionId}`}
              className="bg-primary-color text-white py-2 mt-4 font-nueu text-xl rounded-md text-center hover:bg-opacity-80 transition-all duration-300 ease-in-out"
            >
              Register
            </Link>
          </div>

        </div>
        {/* details */}
      </div>


      <div
        className="w-11/12 mx-auto my-12 flex flex-col justify-center items-center"
        ref={speakersRef}
      >
        <h2 className="text-4xl font-semibold my-8 text-primary-color font-nueu text-center">
          Meet the Speakers
        </h2>
        <div className="grid grid-rows-1 grid-cols-1 overflow-x-auto md:grid-cols-4 items-center gap-4 md:gap-2 w-11/12 justify-center mx-auto">
          {data.map((speaker, index) => (
            <div
              key={index}
              className=" flex flex-col items-center gap-2 text-center"
            >
              <img
                src={speaker.img}
                alt={speaker.name}
                className=" w-[200px] h-[200px] md:w-[200px] md:h-[200px] rounded-full object-contain object-bottom bg-gradient-to-br from-primary-color to-secondary-color"
              />
              <h1 className="text-2xl md:text-lg font-semibold text-secondary-color font-nueu">
                {speaker.name}
              </h1>
              <p className="text-sm  text-slate-700 w-4/5 md:w-11/12">{speaker.position}</p>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SingleSession;
